/* eslint-disable no-nested-ternary */
import { PRODUCTION, STAGING } from '../../utils/constants';
/*------------------------------------*\
    # Project Colors
\*------------------------------------*/
export const Colors = {
  akBlue: '#6d9ab8',
  darkBlue: '#0b2e4d',
  lightBlue: '#04a3d7',
  lightBlueHover: '#0484af',
  veryLightBlue: '#bce0fd',
  red: '#f20a05',
  redOrange: '#ff2526',
  cosmos: '#ffdbdb',
  svDarkBrown: PRODUCTION ? '#3c1a1a' : STAGING ? '#06437a' : '#7002b0',
  svBrown: PRODUCTION ? '#673432' : STAGING ? '#1786b4' : '#cc75ff',
  svDarkRed: '#9b3232',
  svRed: '#d82a2d',
  nRed: '#eb4034',
  svOrange: '#ef7f1a',
  svDarkOrange: '#e86b47',
  softOrange: '#e3cab3',
  white: '#ffffff',
  softGreen: '#acd6a5',
  nGreen: '#dbffee',
  lightYellow: '#Fbf8e5',

  pastelLightOrange: '#FFDABA',
  pastelDarkOrange: '#FAB894',
  pastelLightPurple: '#CB99C8',
  pastelDarkPurple: '#A087C3',

  gray: '#f4f4f4',
  darkGray: '#929292',
  expiredGray: '#cfcfcf',

  newOrage: '#EF7D00',
  darkRed: '#8C2927',
  darkBrown: '#642B26',
  slateGray: '#A7A7A7',
};

/*------------------------------------*\
    #Other variables
\*------------------------------------*/
export const Height = {
  footerHeight: '60px',
  navbarHeight: '86px',
  mt50: '50px',
  mb50: '50px',
  checkedColor: '#1877c1',
  uncheckedColor: '#888',
};
